import { Link, useLocation } from "react-router-dom";
import { fueraDeLaLeccion } from "@/lib/pantallaDeLeccion.mjs";
import { completo as completoLegal } from "@/data/legal/responsable";
import AALogo from "./AALogo";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const { pathname } = useLocation();
  return (
    <footer className={`bg-alpha-black text-white pt-20 pb-8 ${fueraDeLaLeccion(pathname)}`} data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 border-b border-white/10 pb-14">
          <div className="lg:col-span-5">
            <AALogo size={40} variant="light" lockup="horizontal" />
            <p className="font-serif-display text-3xl md:text-4xl leading-tight mt-8 max-w-md">
              Aprender es transformarse.
            </p>
            <p className="text-white/60 text-sm mt-4 max-w-md text-justify">
              Humanidades desde 1.º de la ESO hasta 2.º de Bachillerato: cinco competencias
              construidas sobre el currículo del BOE, con un mentor que pregunta en vez de
              responder.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-alpha text-[11px] uppercase tracking-widest text-white/40 mb-4">
              Plataforma
            </div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/mundo" className="hover:text-alpha-red transition-colors">El Ágora</Link></li>
              <li><Link to="/origen" className="hover:text-alpha-red transition-colors">Origen</Link></li>
              <li><Link to="/cursos" className="hover:text-alpha-red transition-colors">Cursos</Link></li>
              <li><Link to="/recuerdos" className="hover:text-alpha-red transition-colors">Recuerdos</Link></li>
              <li><Link to="/precios" className="hover:text-alpha-red transition-colors">Precios</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-alpha text-[11px] uppercase tracking-widest text-white/40 mb-4">
              Empezar
            </div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/tests" className="hover:text-alpha-red transition-colors">Los tests</Link></li>
              {/* «Explorar cursos» llevaba a /cursos, igual que «Cursos» en la columna de
                  al lado: dos nombres distintos para la misma pagina, uno al lado del otro.
                  El catalogo se queda en Plataforma, que es donde se busca. */}
              <li><Link to="/origen/metodologia" className="hover:text-alpha-red transition-colors">Conocer la metodología</Link></li>
              <li><Link to="/precios" className="hover:text-alpha-red transition-colors">Reservar clase</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-alpha text-[11px] uppercase tracking-widest text-white/40 mb-4">
              Contacto
            </div>
            <a
              href="mailto:hola@academialpha.com"
              className="text-sm hover:text-alpha-red transition-colors flex items-center gap-1"
              data-testid="footer-email"
            >
              hola@academialpha.com <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
            <Link
              to="/contacto"
              className="mt-4 inline-flex items-center gap-1 text-sm hover:text-alpha-red transition-colors"
              data-testid="footer-contact-link"
            >
              Formulario de contacto <ArrowUpRight className="w-3.5 h-3.5" />
            </Link>
            {/* AQUÍ NO VA NADA. Hubo una línea «un espacio híbrido entre universidad,
                laboratorio y estudio creativo», que no decía qué es esto; al cambiarla por una
                descripción de verdad quedó diciendo lo mismo que el bloque de la izquierda,
                dos columnas más allá y en la misma pantalla. Una descripción repetida no
                convence el doble: se lee como relleno. La columna de Contacto es para
                contactar. */}
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div className="font-mono-alpha text-[11px] uppercase tracking-widest text-white/40">
            © {new Date().getFullYear()} Academia Alpha — Aprender es transformarse.
          </div>
          {/* LOS TRES ENLACES IBAN A `#`. Estuvieron así desde el principio: la palabra
              «Privacidad» en el pie y detrás, nada. Ahora llevan a los textos de verdad, y
              SOLO SE PINTAN cuando la identificación del responsable está completa: un aviso
              legal sin el NIF de quien responde aparenta informar sin hacerlo, y prefiero un
              pie sin enlaces a un enlace que miente. Lo vigila `tools/check_legal.py`. */}
          {completoLegal() && (
            <div className="flex gap-6 text-[11px] font-mono-alpha uppercase tracking-widest text-white/40">
              <Link to="/legal/privacidad" className="hover:text-white transition-colors">Privacidad</Link>
              <Link to="/legal/condiciones" className="hover:text-white transition-colors">Condiciones</Link>
              <Link to="/legal/cookies" className="hover:text-white transition-colors">Cookies</Link>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}
